import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/dtcs'

const list = async (curPage, cseq, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage,
      cseq: cseq,
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data)
      } else {
        result(null)
      }
    })

}

export default {
  list
}

export {}
